import { WorkspaceAgentKeysPage } from "@/features/workspaces/workspace-agent-keys.page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/workspaces/$slug/agent-keys")({
  component: WorkspaceAgentKeysPage,
});
